const WrapperStyles = theme => ({
  root: {
    padding: theme.spacing.unit
  }
});

export default WrapperStyles;


// WEBPACK FOOTER //
// ./src/styles/Wrapper.js